function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg085AmericanSamoa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 507.793
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "512,36.632 59.699,259.41 512,482.189 512,512 0,259.41 512,6.822 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F0F0F0"
    },
    points: "512,431.849 512,482.189 59.699,259.41 512,36.632 512,86.973 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M493.301,253.493h-29.275c7.612-9.139,7.141-22.736-1.432-31.31c9.084-9.082,9.084-23.81,0-32.895  l-0.546,0.549c9.082-9.082,9.63-24.359,0.546-33.441L331.019,287.971c9.084,9.085,23.552,8.976,32.634-0.108l2.532-2.314  l63.003-5.728v27.097h21.37v-29.04l32.056-2.913L493.301,253.493z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "333.03,316.084 311.652,305.399 333.03,294.714 471.938,294.714 471.938,316.084 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg085AmericanSamoa);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTA3Ljc5MyIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRDgwMDI3OyIgcG9pbnRzPSI1MTIsMzYuNjMyIDU5LjY5OSwyNTkuNDEgNTEyLDQ4Mi4xODkgNTEyLDUxMiAwLDI1OS40MSA1MTIsNi44MjIgIi8+Cjxwb2x5bGluZSBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSI1MTIsNDMxLjg0OSA1MTIsNDgyLjE4OSA1OS42OTksMjU5LjQxIDUxMiwzNi42MzIgNTEyLDg2Ljk3MyAiLz4KPHBhdGggc3R5bGU9ImZpbGw6I0EyMDAxRDsiIGQ9Ik00OTMuMzAxLDI1My40OTNoLTI5LjI3NWM3LjYxMi05LjEzOSw3LjE0MS0yMi43MzYtMS40MzItMzEuMzFjOS4wODQtOS4wODIsOS4wODQtMjMuODEsMC0zMi44OTUgIGwtMC41NDYsMC41NDljOS4wODItOS4wODIsOS42My0yNC4zNTksMC41NDYtMzMuNDQxTDMzMS4wMTksMjg3Ljk3MWM5LjA4NCw5LjA4NSwyMy41NTIsOC45NzYsMzIuNjM0LTAuMTA4bDIuNTMyLTIuMzE0ICBsNjMuMDAzLTUuNzI4djI3LjA5N2gyMS4zN3YtMjkuMDRsMzIuMDU2LTIuOTEzTDQ5My4zMDEsMjUzLjQ5M3oiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMzMzLjAzLDMxNi4wODQgMzExLjY1MiwzMDUuMzk5IDMzMy4wMywyOTQuNzE0IDQ3MS45MzgsMjk0LjcxNCA0NzEuOTM4LDMxNi4wODQgIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };